import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const ABB_REQUEST = 'ABB_REQUEST';
export const ABB_SUCCESS = 'ABB_SUCCESS';
export const ABB_ERROR = 'ABB_ERROR';

const requestABBData = () => {
	return {
		type: ABB_REQUEST
	};
};

const receiveABBDataSuccess = data => {
	return {
		type: ABB_SUCCESS,
		data
	};
};

const receiveABBDataError = error => {
	return {
		type: ABB_ERROR,
		error
	};
};

export function fetchABBData(params) {
	return dispatch => {
		dispatch(requestABBData());
		const path = `/api/1/abb/redemption/details?lid=${params.lid}&pid=${params.pid}&oid=${params.oid}&cid=${params.cid}&pin=${params.pin}`;

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: path,
				acceptErrors: true
			})
		).then(
			json => dispatch(receiveABBDataSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveABBDataError(err));
				return Promise.reject(err);
			}
		);
	};
}
